var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('div',{staticClass:"status-bar"},[_c('span',{staticClass:"item"},[_vm._v(_vm._s(_vm.tokenExpiredTimeLeftFormatted))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }